import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AcknowledgementPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Acknowledgement</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              We are grateful to (i) APN Network for climate change
              [ARCP2012-FP03-Sellers] for the financial support to carryout
              research &ndash; Mega Regional Development and Environmental
              change in India and China, <br />
              (ii) the NRDMS Division, The Ministry of Science and Technology,
              Government of India;
              <br /> (iii) Indian Institute of Science and
              <br /> (iv) Indian Institute of Technology, Kharagpur <br />
              (V) SERB, Department of Science and Technology for infrastructure
              and financial support.
              <br /> We thank (i) United States Geological Survey
              (http://landcover.usgs.gov/) and (ii) National Remote Sensing
              Centre (NRSC-Hyderabad: http://www.nrsc.gov.in) for providing
              temporal remote sensing data.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AcknowledgementPage;
